import { render } from "./CustomerComponent.vue?vue&type=template&id=43a2756a"
import script from "./CustomerComponent.vue?vue&type=script&lang=js"
export * from "./CustomerComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/customers/CustomerComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "43a2756a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('43a2756a', __exports__)) {
    api.reload('43a2756a', __exports__)
  }
  
  module.hot.accept("./CustomerComponent.vue?vue&type=template&id=43a2756a", () => {
    api.rerender('43a2756a', render)
  })

}


export default __exports__